import { render, staticRenderFns } from "./ConsultBranchesHubsAddAdvisor.vue?vue&type=template&id=2b3d514a"
import script from "./ConsultBranchesHubsAddAdvisor.vue?vue&type=script&lang=ts"
export * from "./ConsultBranchesHubsAddAdvisor.vue?vue&type=script&lang=ts"
import style0 from "./ConsultBranchesHubsAddAdvisor.vue?vue&type=style&index=0&id=2b3d514a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports